import React from "react";
import { Box } from "@mui/material";

export const FullHeightContainer: React.FC<
  React.PropsWithChildren<unknown>
> = ({ children }) => {
  return <Box sx={{ height: "100vh" }}>{children}</Box>;
};
